import React, { Component } from 'react';
import { Button } from 'react-bootstrap';

export default class DynamicArrayField extends Component {
    handleAddRow = () => {
        const { fieldDef, value, onChange } = this.props;
        const rows = value || [];
        const newRow = {};
        if (fieldDef.subFields) {
            fieldDef.subFields.forEach((sf) => {
                newRow[sf.fieldId] = sf.defaultValue || '';
            });
        }
        onChange(fieldDef.fieldId, [...rows, newRow]);
    };

    handleRemoveRow = (index) => {
        const { fieldDef, value, onChange } = this.props;
        const rows = [...(value || [])];
        rows.splice(index, 1);
        onChange(fieldDef.fieldId, rows);
    };

    handleSubFieldChange = (rowIndex, subFieldId, subValue) => {
        const { fieldDef, value, onChange } = this.props;
        const rows = [...(value || [])];
        rows[rowIndex] = { ...rows[rowIndex], [subFieldId]: subValue };
        onChange(fieldDef.fieldId, rows);
    };

    render() {
        const { fieldDef, value, disabled } = this.props;
        const rows = value || [];
        const subFields = fieldDef.subFields || [];
        const isRequired = fieldDef.validation && fieldDef.validation.required;

        return (
            <div className="form-group">
                <label className='my-2'>
                    {fieldDef.label}
                    {isRequired && <span className="text-danger"> *</span>}
                </label>
                {rows.map((row, rowIndex) => (
                    <div key={rowIndex} className="row form-row mb-2" style={{ border: '1px solid #eee', padding: '8px', borderRadius: '4px' }}>
                        {subFields.map((sf) => (
                            <div key={sf.fieldId} className={'col-12 col-md-' + (sf.colSpan || 6)}>
                                <div className="form-group">
                                    <label>{sf.label}</label>
                                    <input
                                        type={sf.type === 'number' ? 'number' : 'text'}
                                        value={row[sf.fieldId] || ''}
                                        onChange={(e) => this.handleSubFieldChange(rowIndex, sf.fieldId, e.target.value)}
                                        placeholder={sf.placeholder || ''}
                                        disabled={disabled}
                                        className="form-control"
                                    />
                                </div>
                            </div>
                        ))}
                        <div className="col-12">
                            <Button
                                variant="outline-danger"
                                size="sm"
                                onClick={() => this.handleRemoveRow(rowIndex)}
                                disabled={disabled}
                            >
                                <i className="fa fa-trash" /> Remove
                            </Button>
                        </div>
                    </div>
                ))}
                <Button
                    variant="outline-info"
                    size="sm"
                    onClick={this.handleAddRow}
                    disabled={disabled}
                    className="mx-2"
                >
                    <i className="fa fa-plus" /> Add Row
                </Button>
            </div>
        );
    }
}
